// Dedicated esbuild entrypoint for the /try marketing configurator island (M11).
// Kept SEPARATE from application.js so the marketing bundle never pulls in the whole
// app (React islands, axios, Sentry, etc.) — /try is the only marketing page that ships
// JavaScript, and it ships only this. Loaded via javascript_include_tag on /try.
import React from "react";
import { createRoot } from "react-dom/client";
import MarketingConfigurator from "./components/MarketingConfigurator";

document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("marketing-configurator");
  if (!el) return;
  const registerPath = el.dataset.registerPath || "/register";
  createRoot(el).render(React.createElement(MarketingConfigurator, { registerPath }));
});
